import Uploader from "@/controller/uploader";
import Auth from "@/controller/auth";

const userPhone = Auth.getUserUid() as string;

export default function useUpload() {
  async function uploadImages(files: FileList): Promise<string[]> {
    const imageUrls: string[] = [];

    for (const file of files) {
      const uploadedUrl = await Uploader.uploadChatImage(userPhone, file);
      imageUrls.push(uploadedUrl);
    }

    return imageUrls;
  }

  return {
    uploadImages
  };
}
